/**
 * Created with JetBrains WebStorm.
 * User: sebastienbeaujard
 * Date: 28/07/13
 * Time: 09:22
 * To change this template use File | Settings | File Templates.
 */

angular.module('FlexyBeautyApp.controllers').
    controller('WebSiteAccountCtrl',["$log","$scope", "$rootScope","CustomerView","CustomerSrv","CustomerData","DaySrv","BookingData","BookingView","$timeout","CategoryData","CategoryView","WebsiteSubdomain",
        "DayView","DayData","SaleView","SaleData","LoyaltyCardItemView","LoyaltyCardItemData","OptInOutService","Auth","$routeParams","WebPreLoaderData","CustomerPostData","ConstantsCustomerPosts",
        function($log,$scope, $rootScope, CustomerView,CustomerSrv,CustomerData,DaySrv,BookingData,BookingView,$timeout,CategoryData,CategoryView,WebsiteSubdomain,
                 DayView,DayData,SaleView,SaleData,LoyaltyCardItemView,LoyaltyCardItemData,OptInOutService,Auth,$routeParams,WebPreLoaderData,CustomerPostData,ConstantsCustomerPosts) {

        $scope.dd = {
            view : {
                displayView : 1,//Display first view by default
                changePwd : false,//on information view
                customerPostViews : [], // on customerPostViews
                modifiedCustomerView:null,
                removedBookingView : null,
                bookedBookingView : null,
                soldSaleView : null,
                loyaltyCardItemView : null,
                nbLoyaltyCardGoal : 0,//reached
                loading : true,
                waitServerResponse : false
            },
            waitingConfirmDelete : false,
            waitingConfirmDeleteId : -1,
            timoutOptInOut : null
        };
        if ($scope.ad.view.bookedBookingView)
        {
            $scope.dd.view.bookedBookingView = $scope.ad.view.bookedBookingView;
            $scope.ad.view.bookedBookingView = null;
        }
        if ($scope.ad.view.soldSaleView)
        {
            $scope.dd.view.soldSaleView = $scope.ad.view.soldSaleView;
            $scope.ad.view.soldSaleView = null;
        }
        if ($scope.ad.view.removedBookingView)
        {
            $scope.dd.view.removedBookingView = $scope.ad.view.removedBookingView;
            $scope.ad.view.removedBookingView = null;
        }

        $scope.updateOptInOut = function(customerId, optInOutView) {
            if (customerId) {
                OptInOutService.update({
                    customerId: customerId,
                    optInOut: optInOutView
                }).then(function (data) {
                    $scope.afterConfidentialitySaveSuccess(data);
                }, function (error) {
                    if (error && error.data) {
                        $scope.afterSaveError(error.status, error.data.message);
                    }
                });
            }
        };

        $scope.createOptInOut = function(customerId, optInOutView) {
            if (customerId) {
                OptInOutService.create({
                    customerId: customerId,
                    optInOut: optInOutView
                }).then(function (data) {
                    $scope.getOptInOut();
                }, function (error) {
                    if (error && error.data) {
                        $scope.afterSaveError(error.status, error.data.message);
                    }
                });
            }
        };
            $scope.$watch('ad.view.loaded', function(newValue, oldValue) {
                if (newValue) {
                    let loginWithToken = function(id, successFunction, errorFunction) {
                        Auth.loginToWebSiteByToken(null, WebPreLoaderData.companyCode, $routeParams.token);
                        CustomerSrv.getById(id, function(customer){
                            console.info("getById ok !!");
                            console.info(customer);
                            $scope.afterGetCustomerWithSuccess(customer);

                            if(successFunction){
                                successFunction(customer);
                            }
                        }, function() {
                            if(errorFunction) {
                                errorFunction("getById Nok !!");
                            }
                        });
                    };
                    let agreementSuccessFunction = function(customer){
                        let customerAgreement = ($routeParams.agreement == 'true');
                        $scope.dd.view.displayView = 5;
                        if(customerAgreement) {
                            $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed = true;
                            $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed = true;
                            $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed = true;
                        }
                        else if(!customerAgreement) {
                            $scope.ad.view.customerView.optInOutView.isSmsCampaignAllowed = false;
                            $scope.ad.view.customerView.optInOutView.isEmailCampaignAllowed = false;
                            $scope.ad.view.customerView.optInOutView.isNotificationCampaignAllowed = false;
                        }
                        $scope.ad.view.customerView.optInOutView.isExternalOptInOut = false;
                        $scope.ad.view.customerView.optInOutView.consentDate = new Date();

                        if ($scope.ad.view.customerView.optInOutView && $scope.ad.view.customerView.optInOutView.id) {
                            $scope.updateOptInOut(customer.id, $scope.ad.view.customerView.optInOutView);
                        } else {
                            $scope.createOptInOut(customer.id, $scope.ad.view.customerView.optInOutView);
                        }

                        afterLoaded();
                    };
                    let bookingSuccessFunction = function(){
                        afterLoaded(function(){
                            let booking = BookingData.getById($routeParams.bookingId);
                            if(booking) {
                                $scope.ad.view.customerView.bookingInfoView = new BookingView(booking, BookingData.getIndexOf(booking), $scope);
                            }
                        });
                    };
                    let initModifiedCustomerView = function(){
                        let customer = $scope.ad.view.customerView.getModel();
                        if (customer){
                            $scope.dd.view.modifiedCustomerView = new CustomerView(customer, $scope.ad.view.customerView.cIndex, $scope);
                            $scope.dd.view.modifiedCustomerView.initCustomerHistoryDatas(customer);
                            $scope.dd.view.customerPostViews = $scope.dd.view.modifiedCustomerView.getPostsViewByCustomerId();
                            $scope.getOptInOut();
                        }

                        $scope.loadView();
                    };
                    let errorFunction = function(errorMessage){
                        //remove cookie and login Anonymous
                        console.info(errorMessage);
                        Auth.clearWebSiteUser(WebPreLoaderData.companyCode);
                        $scope.loginAnonymous();
                    };
                    let afterLoaded = function(endFunction){
                        if (!$scope.ad.view.customerView) {
                            console.info("!!!$scope.ad.view.customerView");
                            $scope.openLocation(WebsiteSubdomain.LOGIN);
                        }
                        else {
                            $scope.dd.bookingDataLoaded = false;
                            $scope.dd.saleDataLoaded = false;
                            $scope.dd.giftItemDataLoaded = false;
                            CustomerSrv.loadRelatedData($scope.ad.view.customerView.getModel(), function() {
                                if(endFunction){
                                    endFunction();
                                }

                                initModifiedCustomerView();
                            });
                        }
                    };

                    if(!$scope.ad.view.categoryRootView){
                        let categoryRoot = CategoryData.categoryRoot;
                        $scope.ad.view.categoryRootView =  new CategoryView(categoryRoot, CategoryData.getIndexOf(categoryRoot), null, $scope);
                    }

                    if ($routeParams.token && $routeParams.id && $routeParams.agreement) {
                        loginWithToken($routeParams.id, agreementSuccessFunction, errorFunction);
                    }
                    else if ($scope.ad.locationPath.indexOf(WebsiteSubdomain.BOOKING) !== -1 && $routeParams.bookingId && $routeParams.customerId && $routeParams.token){
                        loginWithToken($routeParams.customerId, bookingSuccessFunction, errorFunction);
                    }
                    else{
                        afterLoaded();
                    }
                }
            });

        $scope.loadView = function()
        {
            var bookings = BookingData.indexBookings;

            if (bookings)
            {
                $scope.ad.view.customerView.pastBookingsView = [];
                $scope.ad.view.customerView.futureBookingsView = [];

                for (var i=0;i<bookings.length;i++)
                {
                    if (bookings[i].day)
                    {
                        var bookingView = new BookingView(bookings[i],BookingData.getIndexOf(bookings[i]),$scope);
                        bookingView.date = DaySrv.getDateFromId(bookings[i].day.id);
                        $scope.ad.view.customerView.addBookingView(bookingView);
                    }
                }
                //console.log($scope.ad.view.customerView);
                $scope.ad.view.customerView.initHistoryView();

                if ($scope.ad.view.customerView.loyaltyCardItemsNotUsedView.length!=0)
                {
                    var loyaltyCardItem = LoyaltyCardItemData.getByIndex($scope.ad.view.customerView.loyaltyCardItemsNotUsedView[0].index);
                    if (loyaltyCardItem.sale)
                    {
                        var dayView = null;
                        if (loyaltyCardItem.sale && loyaltyCardItem.sale.day)
                            dayView = new DayView(DayData.getIndexOf(loyaltyCardItem.sale.day));
                        var saleView = new SaleView(loyaltyCardItem.sale,SaleData.getIndexOf(loyaltyCardItem.sale),dayView,null,$scope.ad.view);
                        $scope.dd.view.loyaltyCardItemView = new LoyaltyCardItemView(loyaltyCardItem,LoyaltyCardItemData.getIndexOf(loyaltyCardItem),0,saleView);
                        let hasLoyaltyCardInShoppingCart = saleView.loyaltyCardItemsView.length > 0;
                        $scope.dd.view.nbLoyaltyCardGoal = $scope.dd.view.loyaltyCardItemView.nbLoyaltyCardGoal(null, null, hasLoyaltyCardInShoppingCart);

                    }
                }
                $scope.ad.view.customerView.initGiftItemsView(true);
            }
            if ($scope.ad.view.currentBookingView)
            {
                for (var i=0;i<$scope.ad.view.currentBookingView.bookingServicesView.length;i++)
                {
                    $scope.ad.view.currentBookingView.bookingServicesView[i].updateCureItemAfterReload($scope.ad.view.customerView.getFirstCureItemToServiceViewByServiceView($scope.ad.view.currentBookingView.bookingServicesView[i].serviceView));
                }
            }
                $scope.dd.view.loading = false;
            $timeout(function() {
                if(window.FB) {
                    window.FB.XFBML.parse();
                }
            },200);
        };
        $scope.afterSaveSuccess = function(customer)
        {
            $scope.dd.view.waitServerResponse = false;
            console.log("afterSaveSuccess")
            console.log(customer)
            if (customer!=null)
            {
                $scope.dd.view.modifiedCustomerView.password = null;//hide by security
                $scope.dd.view.modifiedCustomerView.passwordAgain = null;//hide by security
                $scope.dd.view.modifiedCustomerView.currentPassword = null;//hide by security
                $scope.ad.view.customerView.loadDataFrom(customer);
                $scope.dd.view.displayView = 1;

            }
        };

        $scope.afterConfidentialitySaveSuccess = function(optInOut) {
            if (optInOut !== null) {
                $scope.ad.view.customerView.optInOutView = optInOut;
                $scope.dd.view.displayView = 5;
            }
        };

        $scope.afterSaveError = function(errorCode,errorMessage)
        {
            console.log(errorMessage);
            $scope.dd.view.errorMessage = errorMessage;
            $scope.dd.view.waitServerResponse = false;

        };
        $scope.removeBookingView = function(bookingView)
        {
            if(bookingView) {
                $scope.dd.view.waitServerResponse = true;
                bookingView.removeModel(function () { // success
                    if ($scope.ad.locationPath.indexOf(WebsiteSubdomain.BOOKING) !== -1) {
                        $scope.ad.view.removedBookingView = bookingView;
                        $scope.ad.view.customerView.bookingInfoView = null;
                        $scope.dd.view.waitServerResponse = false;
                        $scope.openLocation(WebsiteSubdomain.ACCOUNT);
                    }
                    else {
                        $scope.dd.view.removedBookingView = bookingView;
                        $scope.dd.view.bookedBookingView = null;
                        $scope.dd.view.soldSaleView = null;
                    }
                }, function() { // error
                    $scope.dd.view.waitServerResponse = false;
                });
            }
        };
        $scope.saveAccount  = function()
        {
            if ($scope.dd.view.modifiedCustomerView && !$scope.dd.view.waitServerResponse)
                if ($scope.dd.view.modifiedCustomerView.canSaveAccountOnWeb($scope.dd.view.changePwd))
                {
                    $scope.dd.view.displayError = false;
                    $scope.dd.view.waitServerResponse = true;
                    var customer = $scope.dd.view.modifiedCustomerView.getModel();
                    $scope.dd.view.modifiedCustomerView.copyDataTo(customer);
                    CustomerSrv.saveAccount(customer,$scope.afterSaveSuccess,$scope.afterSaveError);
                }
                else
                    $scope.dd.view.displayError = true;
        };

        $scope.getOptInOut  = function() {
            let customerView = $scope.ad.view.customerView.getModel();

            OptInOutService.get({
                customerId: customerView.id
            }).then(function (data) {
                if (data && $scope.dd.view.modifiedCustomerView) {
                    $scope.dd.view.modifiedCustomerView.optInOutView = data;
                }
            }, function (error) {
                if (error && error.data) {
                    $scope.afterSaveError(error.status, error.data.message);
                }
            });
        };

        $scope.saveOptInOut = function() {
            if ($scope.dd.view.modifiedCustomerView) {
                let customer = $scope.dd.view.modifiedCustomerView.getModel();

                if($scope.dd.timoutOptInOut) {
                    $timeout.cancel($scope.dd.timoutOptInOut);
                }

                $scope.dd.timoutOptInOut = $timeout(function(){
                    let optInOutView = $scope.dd.view.modifiedCustomerView.optInOutView;
                        optInOutView.isExternalOptInOut = false;
                        optInOutView.consentDate = new Date();

                    if (optInOutView && optInOutView.id) {
                        $scope.updateOptInOut(customer.id, optInOutView);
                    } else {
                        $scope.createOptInOut(customer.id, optInOutView);
                    }
                },1000);
            }
        };
        $scope.deleteCustomerPost = function(customerPostView){
            var index =  $scope.dd.view.customerPostViews.indexOf(customerPostView);
            if (index!==-1)
            {
                $scope.dd.view.customerPostViews.splice(index, 1);
            }
            customerPostView.removeModel();
        }

        $scope.setWaitingStateCustomer = function(customerPostV, isWaitingDelete){
            if(isWaitingDelete){
                $scope.dd.waitingConfirmDeleteId = customerPostV.getModel().getId();
            }
            else {
                $scope.dd.waitingConfirmDeleteId = -1;
            }
            $scope.dd.waitingConfirmDelete = isWaitingDelete;
        }


        $scope.getCharColor = function(firstName){
            var color = ConstantsCustomerPosts[$scope.getFirstLetterFirstName(firstName)];
            return color;
        }

        $scope.getFirstLetterFirstName = function(firstName){
            if(firstName != null)
                return firstName.charAt(0);
            else
                return "?";
        }

    }]);



// WEBPACK FOOTER //
// ./js/controllers/customerSite/WebSiteAccountCtrl.js